<template>
  <div>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_template_indicator"
      size="xl"
      hide-header
      ok-only
      @ok="addIndicator"
    >
      <SelectSearch
        :title="$lang.indicator"
        :url="indicator_url"
        v-model="Indicator"
        :allowFields="$lang.template_competency_select_without_share_fields"
        :limitOneSelect="false"
        :visibleSearch="true"
      />
      <template v-slot:modal-footer>
        <b-button
          variant="success"
          @click="
            addIndicator();
            view_template_indicator = false;
          "
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button variant="danger" @click="view_template_indicator = false">
          {{ $lang.cancelButton }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_edit_evidance"
      size="xl"
      hide-header
      hide-footer
    >
      <AddEditEvidence
        :item="evidance"
        :evidance_exercise_id="evidance_exercise_id"
        :viewMood="viewMood"
        :valueIndicator="valueIndicator"
        @modal-close="evidanceModal"
      >
        <template slot="title-bar">
          <strong v-text="`${$lang.indicator}: `" />
          <i
            :class="
              valueIndicator === 'مثبت'
                ? `fa fa-plus text-success`
                : `fa fa-minus text-danger`
            "
          />
          {{ pathOr(null, ["caption"], indicatorSelected) }}
          <br />
          <strong v-text="`${$lang.exercise}: `" />{{ nameExercise }}
        </template>
      </AddEditEvidence>
    </b-modal>
    <b-col v-if="componentSearchFilter">
      <searchFilter
        :items="table_data"
        :headers="headers_fields"
        :filters="filters"
        :title="exercise_title"
        :changePage="changePage"
        :current-page="1"
        :perPage="perPage"
        :total_pages="totalPages"
        :totalRows="totalRows"
        :pageLoading="loading"
        :remove_item="removing"
        @chooseEvidance="evidanceChoose"
        @changeSelected="saveExerciseDesign"
        @getRelatedRow="getCompetencyIndicator"
        @clone="clone"
        @fetchData="fetchData"
      >
        <template slot="headerButtons">
          <b-button
            class="ml-2 btn-lightgray"
            @click="showTemplateIndicator"
            v-b-tooltip.hover
            :title="$lang.search.add_tooltip"
          >
            <i class="fa fa-plus"></i>
          </b-button>
        </template>
      </searchFilter>
    </b-col>
    <b-col v-else>
      <DragTable
        :url="exercise_design_evidance_url"
        ref="evidance_search"
        :dynamicButtons="buttonsIndicators"
        :keyLang="`exercise_design_evidance`"
        :order_url="$config.kanoon.evidence_order"
        :keyGroup="`exercise_design_id`"
        :order_by="`order:asc`"
        :permissionButtons="permissions"
        @edit-item="editEvidance"
        :editRoute="true"
        :removeLabel="$lang.exercise_remove"
        :remove_item="removeEvidance"
        :hasAdd="isAdmin(permissions, ['admin'])"
        @handleAdd="showAddEvidenceModal"
        :extraButtons="extraButtons"
      >
        <template slot="title-bar">
          <strong v-text="`${$lang.indicator}: `" />
          <i
            :class="
              valueIndicator === 'مثبت'
                ? `fa fa-plus text-success`
                : `fa fa-minus text-danger`
            "
          />
          {{ pathOr(null, ["caption"], indicatorSelected) }}
          <br />
          <strong v-text="`${$lang.exercise}: `" />{{ nameExercise }}
        </template>
      </DragTable>
    </b-col>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="clone_indicator_modal"
      size="xl"
      hide-header
      hide-footer
    >
      <div class="text-center" v-if="!isCloneLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <b-form @submit.prevent="cloneIndicator" v-if="isCloneLoading">
        <b-row>
          <b-col cols="12" md="12">
            <b-form-group
              :label="$lang.exercise"
              label-for="exercise"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.exercise"
                :rules="$v.exercise_selected.$params"
              />
              <selectFind
                :options="exercise_options"
                v-model="$v.exercise_selected.$model"
                label="text"
                id="value"
                :isValid="
                  $v.exercise_selected.$dirty
                    ? !$v.exercise_selected.$error
                    : null
                "
                :loading="exercise_Loading"
                @input="getListIndicator"
              />
              <b-form-invalid-feedback
                :style="{
                  display: $v.exercise_selected.$error ? 'block' : 'none',
                }"
                id="timeing_selected_feedback"
              >
                {{ $lang.error_required | replace($lang.timeing) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="12">
            <b-form-group
              :label="$lang.indicator"
              label-for="indicator"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.indicator"
                :rules="$v.indicator_selected.$params"
              />
              <selectFind
                :options="indicator_options"
                v-model="$v.indicator_selected.$model"
                label="text"
                id="value"
                :isValid="
                  $v.indicator_selected.$dirty
                    ? !$v.indicator_selected.$error
                    : null
                "
                :loading="indicator_Loading"
              />
              <b-form-invalid-feedback
                :style="{
                  display: $v.indicator_selected.$error ? 'block' : 'none',
                }"
                id="indicator_selected_feedback"
              >
                {{ $lang.error_required | replace($lang.indicator) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" class="float-right">
            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                <i class="fa fa-check"></i>
                {{ $lang.submitButton }}
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="closeCloneModal"
              >
                <i class="fa fa-ban"></i>
                {{ $lang.cancelButton }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="evidance_sample_modal"
      size="xl"
      hide-header
      hide-footer
    >
      <DragTable
        :title="$lang.sample_evidence"
        :url="exercise_design_evidance_sample_url"
        ref="evidance_sample"
        :dynamicButtons="buttonsIndicators"
        :keyLang="`search_evidance_sample`"
        :hasMoving="false"
        :editRoute="false"
        :removeLabel="$lang.exercise_remove"
      />
      <b-row>
        <b-col cols="12" md="12" class="float-right">
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="evidance_sample_modal = false"
            >
              <i class="fa fa-ban"></i>
              {{ $lang.close }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_competency_indicator"
      size="xl"
      hide-header
      ok-only
    >
      <DragTable
        :showCheckbox="false"
        :title="$lang.related_competency"
        :url="competency_indicator_url"
        ref="competency_indicator"
        :dynamicButtons="buttonsCompetencyIndicator"
        :permissionButtons="permissions"
        :keyLang="`competencyIndicatorFields`"
        :hasMoving="false"
        :editRoute="false"
        :removeLabel="$lang.exercise_remove"
      />
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="closeCompetencyIndicator">
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import DragTable from "@/components/base/dragTable";
import SelectSearch from "@/components/base/selectSearch";
import SearchFilter from "@/components/base/searchFilter";
import AddEditEvidence from "./../../evidence/add_edit_evidence";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl, isAdmin } from "@/shared/utils";

export default {
  name: "exercise-design-page",
  components: {
    SearchFilter,
    SelectSearch,
    DragTable,
    AddEditEvidence,
  },
  validations: {
    exercise_selected: {},
    indicator_selected: {},
  },
  data() {
    return {
      hiddenFields: ["caption_imperative", "caption_third_person"],
      competencys_indicators: [],
      page: "1",
      viewCount: 100,
      inputSearch: "",
      perPage: 0,
      totalPages: 0,
      totalRows: 0,
      viewMood: "",
      evidance: null,
      nameExercise: "",
      evidance_exercise_id: null,
      url: this.$config.api_url + this.$config.kanoon.exercise_indicator,
      IndicatorLoading: false,
      id: +this.$route.params.id,
      componentSearchFilter: true,
      edit_evidance_id: null,
      view_template_indicator: false,
      indicator_url: this.$config.api_url + this.$config.kanoon.indicator,
      exercise_competency_indicator_url:
        this.$config.api_url +
        this.$config.kanoon.exercise_competency_indicator,
      buttonsIndicators: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "sample_evidence",
          click: this.sample_evidence,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      buttonsCompetencyIndicator: [
        {
          id: "3",
          name: "delete",
          click: this.deleteCompetencyIndicator,
        },
      ],
      exercise_design_evidance_url: null,
      view_edit_evidance: false,
      Indicator: [],
      table_data: [],
      headers_fields: [],
      loading: false,
      filters: {},
      permissions: [],
      exercise: "",
      exercise_type: "",
      exercise_selected: null,
      exercise_Loading: false,
      exercise_options: [],
      indicator_selected: null,
      indicator_Loading: false,
      indicator_options: [],
      itemClone: {},
      clone_indicator_modal: false,
      isCloneLoading: false,
      evidance_sample_modal: false,
      indicator_id: null,
      exercise_design_evidance_sample_url: null,
      competency_indicator_url: null,
      view_competency_indicator: false,
      indicatorSelected: null,
    };
  },
  computed: {
    exercise_title() {
      const exerciseName = `<span>${this.$lang.exerciseName}: </span>
        <strong>${this.nameExercise}</strong>`;
      const exerciseType = `<br />
        <span>${this.$lang.exerciseType}: </span>
        <strong>${this.exercise_type}</strong>`;
      return this.exercise_type ? exerciseName + exerciseType : exerciseName;
    },
    templateCompetencyUrl() {
      return generateApiUrl(["kanoon", "template_competency"], [this.id]);
    },
    valueIndicator() {
      return pathOr(null, ["value", "caption"], this.indicatorSelected);
    },
    extraButtons() {
      return [
        {
          name: "backComponentSearchFilter",
          condition: true,
          title: this.$lang.back,
          click: this.backComponentSearchFilter,
          iconName: "reply",
        },
      ];
    },
  },
  created() {
    this.fetchData();
    this.getExercise();
  },
  methods: {
    pathOr,
    generateApiUrl,
    isAdmin,
    async removing(item) {
      try {
        const id = pathOr(null, ["indicator", "id"], item);
        const url = generateApiUrl(
          ["kanoon", "exercise_indicator_id"],
          [this.id, id]
        );
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.fetchData();
        return true;
      } catch (error) {
        this.$generateError(error);
      }
    },
    async deleteCompetencyIndicator(item) {
      try {
        const competencyId = pathOr(null, ["competency", "id"], item);
        const indicatorId = pathOr(null, ["indicator", "id"], item);
        const url = generateApiUrl(
          ["kanoon", "competency_indicator_id"],
          [competencyId, indicatorId]
        );
        const response = await this.$httpService.delete(url);
        this.view_competency_indicator = false;
        this.$notify.success(response.data.message);
        this.fetchData();
      } catch (error) {
        this.$generateError(error);
      }
    },
    getCompetencyIndicator(item) {
      this.view_competency_indicator = true;
      const indicator_id = pathOr(null, ["indicator", "id"], item);
      this.competency_indicator_url = generateApiUrl(
        ["kanoon", "competency_indicator_filter"],
        [],
        { indicator_id }
      );
    },
    closeCompetencyIndicator() {
      this.view_competency_indicator = false;
    },
    sample_evidence(item) {
      this.exercise_design_evidance_sample_url =
        this.$config.api_url +
        this.$config.kanoon.exercise_indicator_evidence_sample
          .replace("{0}", this.$route.params.id)
          .replace("{1}", this.indicator_id)
          .replace("{2}", item.id);
      this.evidance_sample_modal = true;
    },
    clone(item) {
      this.clone_indicator_modal = true;
      this.itemClone = item;
      this.getListExercise();
      this.isCloneLoading = true;
    },
    closeCloneModal() {
      this.$v.$reset();
      this.clone_indicator_modal = false;
    },
    async cloneIndicator() {
      try {
        let indicator_id =
          this.itemClone.indicator_object && this.itemClone.indicator_object.id;
        let url =
          this.$config.api_url +
          this.$config.kanoon.exercise_indicator_evidence_duplicate
            .replace("{0}", this.$route.params.id)
            .replace("{1}", indicator_id);
        let payload = {
          exercise_id: this.exercise_selected && this.exercise_selected.value,
          indicator_id:
            this.indicator_selected && this.indicator_selected.value,
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.fetchData();
        this.closeCloneModal();
      } catch (error) {
        this.$generateError(error);
      }
    },
    async getListExercise() {
      try {
        this.exercise_Loading = true;
        const response = await this.$httpService.get(
          this.$config.api_url + this.$config.kanoon.exercise + `/combo`
        );
        let { data } = response.data;
        this.exercise_options = data.map((x) => {
          return {
            text: x.name,
            value: x.id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.exercise_Loading = false;
      }
    },
    async getListIndicator(item) {
      try {
        this.indicator_Loading = true;
        const response = await this.$httpService.get(
          this.$config.api_url +
            this.$config.kanoon.exercise_indicator.replace("{0}", item.value) +
            `?per_page=200`
        );
        let { result } = response.data.data;
        this.indicator_options = result.map((x) => {
          return {
            text: x.indicator && x.indicator.caption,
            value: x.indicator && x.indicator.id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.indicator_Loading = false;
      }
    },
    closeModal() {
      this.$emit("modal-end-up");
    },
    cancelEvidance() {
      this.view_edit_evidance = false;
      this.evidance = null;
      this.status = null;
    },
    showTemplateIndicator() {
      const set = new Set(
        this.table_data.map((x) => pathOr(null, ["indicator", "id"], x))
      );
      this.Indicator = [...set.values()].map((x) => {
        return {
          id: x,
        };
      });
      this.view_template_indicator = true;
    },
    addIndicator() {
      this.IndicatorLoading = true;
      let payload = {
        indicator_id: this.Indicator.map((c) => c.id),
      };

      return this.$httpService
        .put(
          this.$config.api_url +
            this.$config.kanoon.exercise_indicator.replace("{0}", this.id),
          payload
        )
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify(err);
        })
        .finally(() => {
          this.fetchData();
          this.IndicatorLoading = false;
        });
    },
    changePage(page) {
      if (page != this.page) {
        this.page = page;
        this.fetchData();
      }
    },
    async fetchData() {
      this.table_data = [];
      this.headers_fields = [];
      try {
        this.loading = true;
        const url = generateApiUrl(["kanoon", "exercise_indicator"], [this.id]);
        const params = {
          page: this.page,
          search_txt: this.inputSearch,
          per_page: this.viewCount,
          order_by: this.order_by,
        };
        const response = await this.$httpService.get(url, params);
        const data = pathOr(null, ["data", "data"], response);
        let result = pathOr(null, ["result"], data);
        this.totalRows = pathOr(null, ["total"], data);
        this.totalPages = pathOr(null, ["total_pages"], data);
        this.perPage = pathOr(null, ["per_page"], data);
        this.permissions = response.data.permissions;
        const filters = {};
        Object.keys(pathOr({}, ["0"], result)).map((x) => {
          if (x !== `related_competency`) {
            filters[x] = [];
          }
        });
        this.filters = filters;

        this.table_data = result.map((x) => {
          return {
            value: pathOr(null, ["indicator", "value"], x),
            indicator_id: pathOr(null, ["indicator", "id"], x),
            indicator: pathOr(null, ["indicator"], x),
            related_competency: pathOr(null, ["competency_count"], x),
            evidence_related: pathOr(null, ["evidence_count"], x),
            id: pathOr(null, ["id"], x),
          };
        });
        if (this.table_data.length) {
          Object.keys(this.table_data[0]).map((col) => {
            if (col in this.$lang && col != "reference") {
              let sorting =
                col == `related_competency` ||
                col == "value" ||
                col == "indicator_id" ||
                col == `evidence_related`
                  ? false
                  : true;

              this.headers_fields.push({
                label: this.$lang[col],
                key: col,
                sortable: sorting,
                filter: false,
              });
            }
          });
          this.headers_fields.push({
            label: this.$lang.search.operation,
            key: "button",
            sortable: false,
            filter: false,
          });
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    editEvidance(item) {
      this.viewMood = `edit`;
      this.view_edit_evidance = true;
      this.evidance = item;
    },
    evidanceModal(val) {
      this.view_edit_evidance = val;
      this.$refs.evidance_search.fetchData();
    },
    removeEvidance(item) {
      let url =
        this.$config.api_url + this.$config.kanoon.evidence + `/${item.id}`;
      return this.$httpService
        .delete(url)
        .then((response) => {
          this.$notify.success(response.data.message);
          this.$refs.evidance_search.fetchData();
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          return false;
        });
    },
    evidanceChoose(data) {
      this.competencySelected = data.competency;
      this.indicatorSelected = data.indicator;
      this.indicator_id = pathOr(null, ["indicator", "id"], data);
      this.componentSearchFilter = false;
      this.evidance_exercise_id = pathOr(null, ["id"], data);
      this.exercise_design_evidance_url = generateApiUrl(
        ["kanoon", "exercise_design_evidence"],
        [this.evidance_exercise_id]
      );
    },
    saveExerciseDesign(row, event) {
      this.loading = true;
      let id = this.id;
      let competency = row.competency_object.id;
      let indicator = row.indicator_object.id;
      let url = this.exercise_competency_indicator_url
        .replace("{0}", id)
        .replace("{1}", competency)
        .replace("{2}", indicator);
      row.selected = event;
      let payload = {
        is_enable: row.selected ? "1" : "0",
      };
      return this.$httpService
        .patch(url, payload)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          return false;
        })
        .finally(() => {
          this.loading = false;
          this.fetchData();
        });
    },
    backComponentSearchFilter() {
      this.componentSearchFilter = true;
      this.fetchData();
    },
    getExercise() {
      if (isNaN(this.id)) {
        this.$notify.error("Not a number!");
        return false;
      }
      return this.$httpService
        .get(
          this.$config.api_url + this.$config.kanoon.exercise + "/" + this.id
        )
        .then((response) => {
          let data = response.data.data;
          this.exercise = data;
          this.nameExercise = data.name;
          this.exercise_type =
            data.type && data.type.enum_caption ? data.type.enum_caption : "";
        })
        .catch((error) => {
          this.$generateError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    showAddEvidenceModal() {
      this.view_edit_evidance = true;
      this.viewMood = "add";
    },
  },
};
</script>
